import React, { Fragment, useEffect } from "react";
import BreachesTab from "./BreachesTab";
import BreachHeaderText from "./BreachHeaderText";
import { breachServiceActive } from "../../util/CommonBreach";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import SafetyScore from "./RiskRating/SafetyScore";

function Breaches() {
    const history = useHistory();
    const dispatch = useDispatch();
    const breachService = useSelector((state: ApplicationState) => (state.breachServiceState ? state.breachServiceState.breachService : null));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        const initialUrl = window.location.href;
        sessionStorage.setItem("initialUrl", encodeURIComponent(initialUrl));
        if (!breachServiceActive(breachService)) {
            history.replace("/breaches/search-breaches");
        }
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <Fragment>
            <div className="row">
                <BreachHeaderText />
            </div>
            <BreachesTab selectedTab="1" />
            <div className="row" id="content">
                <div className="col-xs-12 col-sm-12">
                    <div className="box">
                        <SafetyScore />
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default Breaches;
